export enum ROUTES {
  LIST_CONTRACTS = '/',
  MAKE_PAYMENT = `/p/:contractNo`,
}